"use client";
import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import emitter from "@packages/lib/eventEmitter/eventEmitter";
import { useRouter, useSearchParams } from "next/navigation";
import { KeyNames } from "@packages/lib/utlils/filters/filterJson";
import { useFilterContext } from "@packages/lib/utlils/use-context/filter-context";
import { cleanUrl } from "@packages/lib/utlils/url-builder";
const FilterIconSvg = dynamic(() => import("./filterIcon-svg"), { ssr: false });
const ResetIconSvg = dynamic(() => import("./resetIcon-svg"), { ssr: false });
const PlusIconSvg = dynamic(() => import("./plusIcon-svg"), { ssr: false });
const DownarrowSvg = dynamic(() => import("./downarrow-svg"), { ssr: false });
import {
  GA4DataLayer,
  GA4DataLayerFn,
} from "@packages/lib/utlils/helper-function";
import {
  GAConstants,
} from "@packages/shared-components/services/constants";
const UcasComponent = dynamic(
  () =>
    import("@packages/shared-components/common-utilities/popups/ucas-calculator/ucascomponent"),
  { ssr: false }
);

const getFilterCookie = () => {
  useEffect(() => {
    const bodyContainer: any = document.getElementById("bodyContainer");
    if (!bodyContainer) {
      return;
    }
    emitter.emit("searchpageloading", false);
    bodyContainer?.classList?.remove("hidden");
  }, []);

  if (typeof document === "undefined") return {};
  const cookieValue = document.cookie.split("filter_param=")[1]?.split(";")[0];
  return JSON.parse(decodeURIComponent(cookieValue || "{}"));
};

const SearchFilterButtons = ({ frompage, commonOldGAAttrs,commonGAAttrs }: { frompage?: any; commonOldGAAttrs?: any,commonGAAttrs?:any }) => {
  const { setrouterEnd } = useFilterContext();
  const currentUrlPath = usePathname();
  const filterCookie = getFilterCookie();
  const searchParams = useSearchParams();
  const router = useRouter();
  const keyName = KeyNames();
  const [filterCount, setFilterCount] = useState(0);
  const [gradeCount, setGradeCount] = useState("");
  const [isUcasPopupOpen, setUcasPopupOpen] = useState(false);
  const isWhatuni = process.env.PROJECT === "Whatuni";
  const [pathname, setPathname] = useState("");
  const pathCookie =
    (typeof document !== "undefined" &&
      document.cookie.split("pathnamecookies=")[1]?.split(";")[0]) ||
    "";
  const locationFilterCount =
    (searchParams?.get(keyName?.location)?.split(" ")?.length || 0) +
    (filterCookie?.location?.split("+")?.length || 0);
  const subjectFilterCount =
    (searchParams?.get(keyName?.subject)?.split(" ")?.length || 0) +
    (filterCookie?.subject?.split("+")?.length || 0);

  const appliedFilters = {
    year: searchParams?.get(keyName?.year)?.split(","),
    month: searchParams?.get(keyName?.month)?.split(","),
    location: searchParams?.get(keyName?.location)?.split(","),
    university: searchParams?.get(keyName?.university)?.split(","),
    qualification: searchParams?.get("qualification")?.split(","),
    studyMethod: searchParams?.get(keyName?.studyMethod)?.split(","),
    locationType: searchParams?.get(keyName?.locationType)?.split(","),
    russellGroup: searchParams?.get(keyName?.russellGroup)?.split(","),
    studyMode: searchParams?.get(keyName?.studyMode)?.split(","),
    subject: searchParams?.get(keyName?.subject)?.split(","),
    distance: searchParams?.get(keyName?.distance)?.split(","),
  };
  const getSelectedFiltersCount = () => {
    const totalCount = Object.values(appliedFilters).reduce(
      (acc, value) =>
        acc + (Array.isArray(value) ? value.filter(Boolean).length : 0),
      0
    );

    delete filterCookie?.subject;
    if (typeof document !== "undefined" && !document.referrer) {
      delete filterCookie?.score;
    }
    const cookieCount =
      filterCookie != null && filterCookie !== undefined
        ? Object.keys(filterCookie)?.length
        : 0;
    return totalCount + (isWhatuni ? 2 : 1) + cookieCount;
  };

  useEffect(() => {
    setPathname(pathCookie);
    setFilterCount(getSelectedFiltersCount());
    setGradeCount(
      searchParams?.has("score") ||
        (typeof document !== "undefined" &&
          document.referrer &&
          filterCookie?.score)
        ? "1"
        : ""
    );
  }, [searchParams, filterCookie, pathCookie]);

  useEffect(() => {
    const bodyContainer: any = document.getElementById("bodyContainer");
    const footer: any = document.getElementById("footerComponent");
    if (!bodyContainer || !footer) {
      return;
    }
    emitter.emit("searchpageloading", false);
    bodyContainer?.classList?.remove("hidden");
    footer?.classList?.remove("hidden");
  }, []);

  const filterEvents = (eventName: string | null | undefined) => {
    GA4DataLayerFn({event:"ga_events", eventName:isWhatuni ? "filter_clicks" : "filters",data_label:eventName == "all" ? "filters" : eventName,...commonOldGAAttrs})
    GA4DataLayer({event:GAConstants.track_event, event_name:"filter_panel_interaction",...commonGAAttrs,click_text:eventName})
    emitter.emit("isfilterOpen", eventName);
    emitter.emit("pauseVideo");
  };

  const toggleUcasPopup = (isOpen: boolean) => {
    setUcasPopupOpen(isOpen);
    GA4DataLayerFn({event:"ga_events", eventName: isWhatuni ? "filter_clicks" : "filters",data_label:"grade_filters",...commonOldGAAttrs})
    GA4DataLayer({event:GAConstants.track_event, event_name:"filter_panel_interaction",...commonGAAttrs,click_text:"Add my grades"})
    document?.body.classList.toggle("overflow-y-hidden", isOpen);
  };

  const resetFilter = () => {
    const university = searchParams?.get(keyName?.university) || "";
    const urlparam = `${university ? `?${keyName?.university}=${university}` : `${process.env.PROJECT === "Whatuni" ? `/${window.location.pathname?.split("/")[1]}` : window.location.pathname}`}`;
    const cookies = ["filter_param={}", "min=", "ucaspoint=", "UCAS="];
    cookies.forEach((cookie) => {
      const isSecure = window.location.protocol === "https:";
      document.cookie = `${cookie}; path=/; ${cookie !== "filter_param={}" ? "max-age=0;" : ""} ${isSecure ? "Secure;" : ""} SameSite=Lax`;
    });
    const finalUrl = cleanUrl(urlparam || window.location.pathname);
    sessionStorage.setItem("filter_param", "{}");
    if (urlparam !== window.location.search) {
      emitter.emit("resetStateValues");
      emitter.emit("refreshFilters");
      emitter.emit("searchresultloading", true);
      setrouterEnd(true);
      const srpageBodySection =
        window?.document?.getElementById("srpageBodySection");
      emitter.emit("providerresultloading", true);
      const prPageBodySection =
        window?.document?.getElementById("prPageBodySection");
      srpageBodySection?.classList?.add("hidden");
      prPageBodySection?.classList?.add("hidden");
      router.prefetch(finalUrl);
      window.history.pushState(null, "", finalUrl);
      router.push(finalUrl);
    }
  };
  return (
    <>
      <section className="bg-grey-600 px-[12px] py-[16px] fixed bottom-0 w-full lg:sticky lg:top-0 z-[4] min-h-[72px] lg:min-h-[64px]">
        <div className="max-w-container mx-auto flex gap-[8px] small">
          {isWhatuni &&
            !currentUrlPath.includes("postgraduate-courses") &&
            !currentUrlPath.includes("csearch") && (
              <button
                type="button"
                className="flex items-center justify-center gap-[8px] btn btn-primary grow w-fit px-[12px] md:px-[16px] lg:grow-0 lg:shrink-0"
                onClick={() => toggleUcasPopup(true)}
              >
                <PlusIconSvg />
                Add my grades {gradeCount && `(${gradeCount})`}
              </button>
            )}
          {isUcasPopupOpen && (
            <UcasComponent
              onClose={() => toggleUcasPopup(false)}
              isUcasOpen={isUcasPopupOpen}
            />
          )}
          <button
            type="button"
            onClick={() => filterEvents("all")}
            className="flex items-center justify-center gap-[8px] btn grow w-fit px-[12px] md:px-[16px] bg-primary-100 hover:bg-primary-200 text-grey300 lg:grow-0 lg:shrink-0"
          >
            <FilterIconSvg />
            Filter ({filterCount})
          </button>
          <div className="hidden lg:flex items-center justify-center gap-[8px] lg:shrink-0">
            <button
              type="button"
              className="flex items-center gap-[8px] btn w-fit px-[12px] md:px-[16px] bg-grey-100 hover:bg-grey-200 text-grey300"
              onClick={() => filterEvents("subject")}
            >
              {isWhatuni ? "Study level" : "Qualification"}
              <DownarrowSvg />
            </button>

            <button
              type="button"
              className="flex items-center gap-[8px] btn w-fit px-[12px] md:px-[16px] bg-grey-100 hover:bg-grey-200 text-grey300"
              onClick={() => filterEvents("subject")}
            >
              Subject {subjectFilterCount > 0 && `(${subjectFilterCount})`}
              <DownarrowSvg />
            </button>
            <button
              type="button"
              className="flex items-center gap-[8px] btn w-fit px-[12px] md:px-[16px] bg-grey-100 hover:bg-grey-200 text-grey300"
              onClick={() => filterEvents("year")}
            >
              Year
              <DownarrowSvg />
            </button>
            <button
              type="button"
              className="flex items-center gap-[8px] btn w-fit px-[12px] md:px-[16px] bg-grey-100 hover:bg-grey-200 text-grey300"
              onClick={() => filterEvents("university")}
            >
              University
              <DownarrowSvg />
            </button>
            {frompage && (
              <button
                type="button"
                className="flex items-center gap-[8px] btn w-fit px-[12px] md:px-[16px] bg-grey-100 hover:bg-grey-200 text-grey300"
                onClick={() => filterEvents("location")}
              >
                Location {locationFilterCount > 0 && `(${locationFilterCount})`}
                <DownarrowSvg />
              </button>
            )}
          </div>
          <button
            type="button"
            className="flex items-center justify-center gap-[4px] cursor-pointer px-0 text-grey-50 hover:underline xl:px-[16px] lg:shrink-0"
            onClick={resetFilter}
          >
            <ResetIconSvg />
            Reset
          </button>
        </div>
      </section>
    </>
  );
};

export default SearchFilterButtons;
